/* 🤖 this file was generated by svg-to-ts */
export const fthrCheckCircle: {
    name: 'fthr-check-circle';
    data: string;
} = {
    name: 'fthr-check-circle',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-check-circle" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4 12 14.01l-3-3"/></svg>`,
};
